/**
 * @generated SignedSource<<f0beb8024834e0692cdf09c58f57dabc>>
 * @relayHash 71a6bdc9b776667078a30235316760ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e76823faddb437fa410f0ee4f0071f1f1833d46e55f21413adf9b54810754c90

import type { ConcreteRequest } from 'relay-runtime';
export type StudioWorkspaceIdLoaderQuery$variables = {
  jiraSiteAri: string;
};
export type StudioWorkspaceIdLoaderQuery$data = {
  readonly admin_unitLinkedResource: {
    readonly id: string;
    readonly links: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      }> | null;
    };
  } | null;
};
export type StudioWorkspaceIdLoaderQuery = {
  response: StudioWorkspaceIdLoaderQuery$data;
  variables: StudioWorkspaceIdLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jiraSiteAri"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "jiraSiteAri"
      }
    ],
    "concreteType": "AdminUnitLinkedResource",
    "kind": "LinkedField",
    "name": "admin_unitLinkedResource",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 10
          }
        ],
        "concreteType": "AdminUnitLinkedConnection",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "concreteType": "AdminUnitLinkedEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AdminUnitLinkedTo",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ],
        "storageKey": "links(first:10)"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StudioWorkspaceIdLoaderQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudioWorkspaceIdLoaderQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "e76823faddb437fa410f0ee4f0071f1f1833d46e55f21413adf9b54810754c90",
    "metadata": {},
    "name": "StudioWorkspaceIdLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fbc2fa57e550872aa23f04f1e66a4104";

export default node;
